import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: process.env.REACT_APP_apiKey,
    authDomain : process.env.REACT_APP_authDomain,
    projectId : process.env.REACT_APP_projectId,
    storageBucket : process.env.REACT_APP_storageBucket,
    messagingSenderId : process.env.REACT_APP_messagingSenderId,
    appId : process.env.REACT_APP_appId,
    measurementId : process.env.REACT_APP_measurementId
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);